import { render, staticRenderFns } from "./outbound-order-detail.vue?vue&type=template&id=60090237&scoped=true&"
import script from "./outbound-order-detail.vue?vue&type=script&lang=js&"
export * from "./outbound-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./outbound-order-detail.vue?vue&type=style&index=0&id=60090237&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60090237",
  null
  
)

export default component.exports